import { render, staticRenderFns } from "./PriviewImg.vue?vue&type=template&id=002a294d&scoped=true&"
import script from "./PriviewImg.vue?vue&type=script&lang=js&"
export * from "./PriviewImg.vue?vue&type=script&lang=js&"
import style0 from "./PriviewImg.vue?vue&type=style&index=0&id=002a294d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002a294d",
  null
  
)

export default component.exports